import { ClientConstantsService } from "./client-constants.service";

export const clientConstantsServiceInstance = ClientConstantsService.instance;
